import React, { useCallback, useEffect } from 'react';
import { Grid, IconButton, CardMedia } from '@mui/material';

interface ImageThumbnailsProps {
  allUrls: string[];
  onSelectImage: (url: string) => void;
  selectedImage: string;
}

const ImageThumbnails: React.FC<ImageThumbnailsProps> = ({
  allUrls,
  onSelectImage,
  selectedImage
}) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const currentIndex = allUrls.indexOf(selectedImage);
      if (event.key === 'ArrowRight') {
        const newIndex =
          currentIndex + 1 < allUrls.length ? currentIndex + 1 : 0;
        onSelectImage(allUrls[newIndex]);
      } else if (event.key === 'ArrowLeft') {
        const prevIndex =
          currentIndex - 1 >= 0 ? currentIndex - 1 : allUrls.length - 1;
        onSelectImage(allUrls[prevIndex]);
      }
    },
    [allUrls, onSelectImage, selectedImage]
  );
  useEffect(() => {
    const handleComponentFocus = () => {
      window.addEventListener('keydown', handleKeyDown);
    };

    handleComponentFocus();

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <div tabIndex={0} style={{ outline: 'none' }}>
      <Grid
        container
        spacing={1}
        sx={{
          padding: 4,
          maxHeight: '150px',
          overflow: 'auto',
          justifyContent: 'center'
        }}
      >
        {allUrls.map((url, index) => (
          <Grid item key={index} xs={4} sm={2} md={1}>
            <IconButton onClick={() => onSelectImage(url)} size="large">
              <CardMedia
                component="img"
                image={url}
                alt={`Thumbnail ${index}`}
                sx={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '2px',
                  border: url === selectedImage ? '2px solid black' : 'none'
                }}
              />
            </IconButton>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ImageThumbnails;
